/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileCodeSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileCodeSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m9.42 9.03-3.526 3.762 3.525 3.76.912-.854-2.724-2.906 2.724-2.906-.912-.855Zm6.953 0-.912.856 2.724 2.906-2.724 2.905.912.855 3.525-3.76-3.525-3.761Zm-2.94-1.795-2.5 10.833 1.217.28 2.501-10.832-1.218-.281Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m10.932 18.068 2.501-10.833 1.218.28-.108.471-1.11-.256-2.392 10.363-.109-.025ZM9.42 9.03l-3.526 3.762.232.247 3.293-3.513.665.623.247-.263-.912-.855Zm.664 6.9.247-.232-2.492-2.659-.232.248 2.477 2.642Zm6.289-6.9-.912.856.247.263.665-.623 3.293 3.513.232-.247-3.525-3.761Zm-.665 6.9 2.477-2.643-.232-.248-2.492 2.659.247.231Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileCodeSmall
};
